import * as ConfigTypes from 'config/ConfigTypes';


class SortHelper {

    sortByValue = ({ data, sorted, field, childObj, isNumber }) => {
        let sortedData = [];
        if (data && data.length) {
            let order = (sorted && sorted === ConfigTypes.DESC) ? -1 : 1;
            sortedData = data.sort((a, b) => {
                let aSort = childObj ? a[childObj][field] : a[field];
                let bSort = childObj ? b[childObj][field] : b[field];
                if (isNumber) {
                    aSort = parseInt(aSort) ? parseInt(aSort) : aSort;
                    bSort = parseInt(bSort) ? parseInt(bSort) : bSort;
                } else {
                    aSort = typeof (aSort) == 'string' ? aSort.toLowerCase() : aSort;
                    bSort = typeof (bSort) == 'string' ? bSort.toLowerCase() : bSort;
                }

                if (aSort && bSort && (aSort > bSort)) return 1 * order;
                if (aSort && bSort && (aSort < bSort)) return -1 * order;
                return 0;
            })
        }
        return sortedData;
    }
}

export default SortHelper = new SortHelper();